import { styled, Theme } from '@mui/material';

import devices from '../../../../styles/devices';
import PickerDate from '../../PickerDate';
import PickerTime from '../../PickerTime';

/**
 * Shared input styles for date/time picker
 *
 * @param theme The theme we use
 * @returns     The styles applied to the input component
 */
const inputStyles = (theme: Theme) => ({
  '& .MuiInputBase-input': {
    color: theme.palette.primary.dark,
    cursor: 'pointer',
  },
  '& .MuiInputBase-input:not(:placeholder-shown)': {
    fontWeight: 'var(--font-weight-text-caption)',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.dark,
  },

  flexGrow: 1,
  width: '100%',
});

export const Section = styled('section')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 'var(--spacing-big)',

  [`@media ${devices.tabletS}`]: {
    padding: 'var(--spacing-small) var(--spacing-big)',
  },
}));

export const WrapperDueDate = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 'var(--spacing-big)',
  justifyContent: 'space-between',

  [`@media ${devices.tabletS}`]: {
    flexDirection: 'row',
  },
}));

export const DatePicker = styled(PickerDate)(({ theme }) => ({
  ...inputStyles(theme),
}));

export const TimePicker = styled(PickerTime)(({ theme }) => ({
  ...inputStyles(theme),
}));
